import type { LoadingState } from '@ipfabric/ui-components/utils/loading/withLoadingIndicator';
import type { GraphState } from 'components/Graph/GraphState';
import { isOneOf } from 'utils/isOneOf';

export const selectGraphLoading = (state: GraphState): boolean =>
  state.longRendering ||
  isOneOf<LoadingState>(state.loading, 'INITIAL', 'LOADING');
